<template lang="pug">
.progress-bar
  icon-circle.icon.base
  icon-circle.icon.progress(ref="icon")

</template>

<script>
import Vue from 'vue'
import IconCircle from '!!vue-svg-loader!src/assets/circle.svg'

export default {
  name: 'progress-bar',
  props: ['progress'],
  components: {
    IconCircle,
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {},
  mounted() {
    Vue.nextTick(() => {
      this.path = this.$refs.icon.$el.querySelector('path')
      this.length = this.path.getTotalLength()
      this.path.style.strokeDasharray = this.length
      this.path.style.strokeDashoffset = this.length
      Vue.nextTick(() => {
        this.path.style.transition = 'all 0.2s linear 0s'
        this.update()
      })
    })
  },
  beforeDestroy() {},
  methods: {
    update() {
      this.path.style.strokeDashoffset = this.length * (1 - this.progress)
    },
  },
  watch: {
    progress() {
      this.update()
    },
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

$size: 60px
$l: 125.68135070800781

.progress-bar
  position: relative
  width: $size
  height: $size
  +flex-center()

.icon
  +center-img()
  fill: none
  stroke: black
  stroke-width: 2px

.base
  stroke-dasharray: 1 5
  animation: spin-clockwise 20s linear infinite

.progress
  stroke-dasharray: $l
  stroke-dashoffset: $l

.label
  font-size: $fs-l

</style>
